/**
 * Interrupteur de « S'exercer » (DRILL) — règle PURE, partagée par le serveur et l'écran.
 *
 * Décision de Valérie (13/10/2026) : la fonctionnalité part en production et en démo avec le
 * reste, mais n'y est pas montrée tant que tout n'est pas prêt (workflow N8N `drillAgent`, fiches,
 * capsules). Elle est ouverte quand la variable d'environnement `DRILL_ENABLED` vaut « true »
 * (posée sur dev et staging) ; l'ADM la voit toujours, pour la vérifier sur l'environnement réel.
 *
 * Côté serveur : `drill-access.service.ts` (critères éligibles vides, création et lancement
 * refusés, suggestions « Exercice » écartées de « Mes sessions » et du mail du lundi).
 * Côté écran : page, lancement et onglets « Historique des exercices » (store ci-dessous,
 * alimenté par `App` depuis `/api/config` et le profil connecté).
 */
export const VARIABLE_DRILL = "DRILL_ENABLED";

export function drillOuvertPour(interrupteurActif: boolean, profileType: string | null | undefined): boolean {
  return interrupteurActif || profileType === "ADM";
}

// ── Store écran (fermé tant qu'on ne sait pas : rien ne clignote puis disparaît) ──
let visible = false;
const abonnes = new Set<() => void>();

export function setDrillVisible(v: boolean): void {
  if (v === visible) return;
  visible = v;
  for (const f of abonnes) f();
}
export function isDrillVisible(): boolean {
  return visible;
}
export function subscribeDrillVisible(f: () => void): () => void {
  abonnes.add(f);
  return () => abonnes.delete(f);
}
